import { render, staticRenderFns } from "./AvailabilityComponent.vue?vue&type=template&id=51d5c0d2&scoped=true"
import script from "./AvailabilityComponent.vue?vue&type=script&lang=js"
export * from "./AvailabilityComponent.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityComponent.vue?vue&type=style&index=0&id=51d5c0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5c0d2",
  null
  
)

export default component.exports